import http from './http-service'
import config from '../config/constant'

const validateAccChequeFlag = async (data) => {
  try {
    const reqParams = {
      accountNo: data.accountNo,
      brnCode: data.brnCode,
      requestId: 'VALIDATEACCCHEQUEFLAG',
    }
    const response = await http.post(config.requests.validateAccChequeFlag, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const verifyCheckbook = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'CHEQUEBOOK',
      deliveryMode: 'B',
    }
    const response = await http.post(config.requests.chequeBook, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const confirmCheckbook = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'CHEQUEBOOK',
      deliveryMode: 'B',
    }
    const response = await http.post(config.requests.chequeBookConfirm, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getAllBranches = async (data) => {
  try {
    const response = await http.post(config.requests.getAllBanksList, {
      requestId: 'GETBRANCHDETAILS',
    })
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const verifyStopCheque = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'STOPCHEQUEBOOK',
    }
    const response = await http.post(config.requests.stopCheque, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const stopChequeConfirm = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'STOPCHECKBOOKCONFIRM',
    }
    const response = await http.post(config.requests.stopChequeConfirm, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const verifySIRequest = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'SIREQUEST',
    }
    const response = await http.post(config.requests.siCreateInit, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const confirmSIRequest = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'SIREQUESTCONFIRM',
    }
    const response = await http.post(config.requests.siConfirmInit, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getSIList = async (data) => {
  try {
    const reqParams = {
      ...data,
      requestId: 'GETSILIST',
    }
    const response = await http.post(config.portfolio.getSIList, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getStopChequeReasonList = async () => {
  try {
    const reqParams = {
      requestId: 'STOPCHEQUEREASONLIST',
    }
    const response = await http.post(config.requests.getStopChequeReasonList, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const verifyChequeStatus = async (data) => {
  try {
    const reqParams = {
      requestId: 'CHEQUESTATUS',
      module: "CHQSTATUS",
      ...data
    }
    const response = await http.post(config.requests.verifyChequeStatus, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const ConfirmChequeStatus = async (data) => {
  try {
    const reqParams = {
      requestId: 'CHEQUESTATUS',
      module: "CHQSTATUS",
      ...data
    }
    const response = await http.post(config.requests.confirmChequeStatus, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const verifyCardRequest = async (data) => {
  try {
    const reqParams = {
      requestId: "DEBITCARDREQUEST",
      module: "DEBITCARD",
      ...data
    }
    const response = await http.post(config.requests.debitCardInit, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const confirmCardRequest = async (data) => {
  try {
    const reqParams = {
      requestId: "DEBITCARDREQUEST",
      module: "DEBITCARD",
      ...data
    }
    const response = await http.post(config.requests.debitCardConfirm, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    return Promise.reject(err)
  }
}

const getCardDetails = async (data) => {
  try{
    const reqParams = {
      ...data
    }
    const response = await http.post(config.requests.getAllCardProducts, reqParams)
    return { status: response.status, data: response.data }
  }catch (err){
    return Promise.reject(err)
  }
}

const getCardList = async () => {
  try {
    const reqParams = {
      requestId: 'CARDLIST',
      module:'DEBITCARD'
    }
    const response = await http.post(config.requests.getAllCardList, reqParams)
    return response.data
  } catch (err) {
    throw err.response.data
  }
}

const blockDebitCardVerify = async (data) => {
  try {
    const reqParams = {
      ...data,
      cardStatus: 'B',
      requestId: 'BLOCKDEBITCARD',
      module: 'CARDSTATUSCHANGE'
    }
    const response = await http.post(config.requests.blockDebitCardVerify, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const blockDebitCardConfirm = async (data) => {
  try {
    const reqParams = {
      ...data,
      cardStatus: 'B',
      requestId: 'BLOCKDEBITCARD',
      module: 'CARDSTATUSCHANGE'
    }
    const response = await http.post(config.requests.blockDebitCardConfirm, reqParams)
    return { status: response.status, data: response.data }
  } catch (err) {
    throw err.response.data
  }
}

const RequestService = {
  getAllBranches,
  verifyCheckbook,
  confirmCheckbook,
  validateAccChequeFlag,
  stopChequeConfirm,
  verifyStopCheque,
  verifySIRequest,
  confirmSIRequest,
  getSIList,
  getStopChequeReasonList,
  verifyChequeStatus,
  ConfirmChequeStatus,
  verifyCardRequest,
  confirmCardRequest,
  getCardDetails,
  getCardList,
  blockDebitCardVerify,
  blockDebitCardConfirm,
}

export default RequestService
